import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  description?: string;
  phase?: number;
}

export function PlaceholderPage({ title, description, phase }: PlaceholderPageProps) {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-text-primary">{title}</h1>
        {description && (
          <p className="mt-1 text-sm text-text-secondary">{description}</p>
        )}
      </div>

      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border-subtle bg-bg-surface py-20 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-bg-surface-2">
          <Construction className="h-7 w-7 text-text-secondary" />
        </div>
        <h2 className="mt-4 text-base font-semibold text-text-primary">{title}</h2>
        <p className="mt-2 max-w-sm text-sm text-text-secondary">
          {phase
            ? `This module is implemented in Phase ${phase}. The shell and navigation are ready.`
            : 'Coming soon — this section is under active development.'}
        </p>
      </div>
    </div>
  );
}
